import React from 'react';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import { Outlet } from 'react-router-dom';
import './DefaultLayout.css'

const DefaultLayout = () => {
    return (
            <div className='default-layout'>
                <Nav />
                <Outlet />
                <Footer />
            </div>
    )
}

export default DefaultLayout;